import { GeoposicionarComponent } from '../componentes/geoposicionamiento/geoposicionar.component';
import { SelectorIdiomaComponent } from '../componentes/selectorIdioma/selectorIdioma.component';
import { TranslateModule, TranslateLoader, TranslateStaticLoader } from 'ng2-translate';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Http } from '@angular/http';
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { TablaAsignacionContenidosComponent } from '../componentes/tabla-asignacion-contenidos/tabla-asignacion-contenidos.component';

export {
	GeoposicionarComponent,
	SelectorIdiomaComponent,
	TablaAsignacionContenidosComponent
};


@NgModule({
	declarations: [
		GeoposicionarComponent,
		SelectorIdiomaComponent,
		TablaAsignacionContenidosComponent
		
	],
	exports: [
		GeoposicionarComponent,
		SelectorIdiomaComponent,
		TablaAsignacionContenidosComponent
	],
	imports: [
		FormsModule,
		TableModule,
		CommonModule,
		TranslateModule.forRoot({
			provide: TranslateLoader,
			useFactory: function (http: Http) { return new TranslateStaticLoader(http, '/assets/i18n', '.json'); },
			deps: [Http]
		})
		

	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class ComponentesModule { }



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/modules/componentes.module.ts